import { FC, ReactNode } from 'react';
import { Button } from './style';
import { TColorSlot } from 'shared/types/stylesTypes';

interface SlotButtonProps {
	children: ReactNode;
	isOpen?: boolean;
	isSelected?: boolean;
	color?: TColorSlot;
	onClick?: () => void;
}

export const SlotButton: FC<SlotButtonProps> = ({
	children,
	isOpen = false,
	isSelected = false,
	color,
	onClick,
}) => {
	return (
		<>
			<Button
				role={`slot-button`}
				$isOpen={isOpen}
				$isSelected={isSelected}
				$color={color}
				onClick={event => {
					event.stopPropagation();
					onClick?.();
				}}
			>
				{isOpen && children}
			</Button>
		</>
	);
};
